'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const RevenueChart = dynamic(() => import('./RevenueChart'), { ssr: false });
const MemberGrowthChart = dynamic(() => import('./MemberGrowthChart'), { ssr: false });

export default function AdminChartsRow() {
  return (
    <div className="space-y-6">
      <RevenueChart />
      <MemberGrowthChart />
    </div>
  );
}